const loginHandler = async service => {
  const user = await service.get("/user/profile");
  const route = getRoutes(user["user_type"]);
  return { user, route };
};

export const getRoutes = (userType) => {
  const routes = {
    org: "/org",
    group: "/group",
    super: "/admin",
    user: "/user",
  };
  return routes[userType] || "/";
};

export default loginHandler;

export const routeAfterLoginOrSignup = (history, routeBasedOnRole, user, showWelcomeFirst, queryStr) => {
  const rt = new URLSearchParams(queryStr || window.location.search).get("redirectTo") || "";
  const allowedRoutes = {
    "/admin": ["/admin"],
    "/org": ["/org", "/group", "/welcome", "/process-invite", "/process-life-time-membership-invite"],
    "/group": ["/group", "/welcome", "/process-invite", "/process-life-time-membership-invite"],
    "/user": ["/user", "/welcome", "/process-invite", "/process-life-time-membership-invite"],
  };
  if (allowedRoutes[routeBasedOnRole].some((_rt) => rt.startsWith(_rt))) {
    history.push(rt, { user });
  } else if (showWelcomeFirst) {
    history.push("/welcome", { user });
  } else {
    history.push(routeBasedOnRole, { user });
  }
};